var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDownload = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "EB72FA16-A1D7-4F52-BE2F-7BEDA0DD13B1")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reports",
    transform: "translate(-530.000000, -307.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FAFAFA",
    x: 0,
    y: 0,
    width: 1280,
    height: 800
  }), /*#__PURE__*/React.createElement("g", {
    id: "Cells/Report-Cell",
    transform: "translate(272.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#F2F2F2",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 479,
    height: 166,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Buttons",
    transform: "translate(63.000000, 127.000000)",
    fill: "#E2136E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-Copy",
    transform: "translate(195.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/ic_cloud_down"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.015625,12.984375 L14.015625,12.984375 L14.015625,9 L9.984375,9 L9.984375,12.984375 L6.984375,12.984375 L12,18 L17.015625,12.984375 Z M19.359375,10.03125 C20.6406314,10.1250005 21.7343705,10.6484327 22.640625,11.6015625 C23.5468795,12.5546923 24,13.6874934 24,15 C24,16.3750069 23.5078174,17.5546826 22.5234375,18.5390625 C21.5390576,19.5234424 20.3593819,20.015625 18.984375,20.015625 L6,20.015625 C4.34374172,20.015625 2.92969336,19.4296934 1.7578125,18.2578125 C0.585931641,17.0859316 0,15.6718833 0,14.015625 C0,12.5468677 0.523432266,11.2265684 1.5703125,10.0546875 C2.61719273,8.88280664 3.87499266,8.21875078 5.34375,8.0625 C6,6.84374391 6.92186906,5.85937875 8.109375,5.109375 C9.29688094,4.35937125 10.593743,3.984375 12,3.984375 C13.6875084,3.984375 15.2578052,4.57811906 16.7109375,5.765625 C18.1640698,6.95313094 19.0468734,8.37499172 19.359375,10.03125 Z",
    id: "c"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download.62f8ff5d.svg";
export { ForwardRef as ReactComponent };